var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.571,16.667h-2.095v-4.19c0-5.783-4.693-10.476-10.476-10.476s-10.476,4.693-10.476,10.476v4.19h-2.095c-2.305,0-4.19,1.886-4.19,4.19v20.952c0,2.305,1.886,4.19,4.19,4.19h25.143c2.305,0,4.19-1.886,4.19-4.19v-20.952c0-2.305-1.886-4.19-4.19-4.19ZM24,35.524c-2.305,0-4.19-1.886-4.19-4.19s1.886-4.19,4.19-4.19,4.19,1.886,4.19,4.19-1.886,4.19-4.19,4.19ZM30.495,16.667h-12.99v-4.19c0-3.583,2.912-6.495,6.495-6.495s6.495,2.912,6.495,6.495v4.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangePassword);
export default __webpack_public_path__ + "static/media/icon-change-password.e9d83725c06687b760db57f8df0b48d3.svg";
export { ForwardRef as ReactComponent };